import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngxs/store';

import { ProfileResponse } from '@smarthead-api/models/profile-response';

import { ProfileState } from '@client/app/profile/state/profile.state';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-profiles-desktop',
  templateUrl: './main-nav-profiles-desktop.component.html',
  styleUrl: './main-nav-profiles-desktop.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MainNavService],
  standalone: false
})
export class MainNavProfilesDesktopComponent {
  #mainNavService = inject(MainNavService);
  #store = inject(Store);

  #routerLinkCreatorService = inject(RouterLinkCreatorService);
  profiles = input.required<ProfileResponse[]>();

  loadedProfile = toSignal(
    // magic to compare route profile id with loaded profile id, as nobody clears the profile state on route change
    this.#store.select(ProfileState.getLoadedProfile),
    { initialValue: null }
  );

  isSuperAdmin$ = this.#mainNavService.isSuperAdmin$;

  profileLink(profile: ProfileResponse) {
    return this.#routerLinkCreatorService.createProfileLink(profile.id, profile.title, false, 'ADMIN-DASHBOARD');
  }

  navigateToCreateProfile() {
    this.#routerLinkCreatorService.navigateToCreateProfile();
  }
}
